// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"ordering-select_shadow__1awty","select":"ordering-select_select__dL5N2"};